<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate"
        >新增</el-button
      >
      <el-input
        v-model="listQuery.name"
        placeholder="请输入学校名称"
        style="width: 150px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="正常" :value="1" />
        <el-option label="冻结" :value="0" />
      </el-select>
      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="学校名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="所在地" min-width="110" align="center">
        <template slot-scope="scope"
          >{{ scope.row.province.name + scope.row.city.name }}
        </template>
      </el-table-column>
      <el-table-column label="账号" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.account }} </template>
      </el-table-column>
      <el-table-column label="冻结状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal == 1" type="success">正常</el-tag>
          <el-tag v-else type="danger">冻结</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="到期时间" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.expire_at }} </template>
      </el-table-column>
      <!-- <el-table-column label="冻结状态" min-width="110" align="center">
        <template slot-scope="scope"> </template>
      </el-table-column> -->

      <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleUpdate(scope.row)"
          >
            修改
          </el-button>
          <el-button
            v-if="scope.row.is_normal == 1"
            size="mini"
            type="danger"
            @click="handleStatus(scope.row.id, '冻结')"
          >
            冻结
          </el-button>
          <el-button
            v-else
            size="mini"
            type="success"
            @click="handleStatus(scope.row.id, '解冻')"
          >
            解冻
          </el-button>
          <el-button size="mini" type="primary" @click="handleMajor(scope.row)">
            专业管理
          </el-button>
          <el-button
            size="mini"
            style="margin-top: 10px"
            type="warning"
            @click="initPassword(scope.row.id, '初始化')"
            >初始化密码</el-button
          >
          <el-button
            size="mini"
            style="margin-top: 10px"
            type="primary"
            @click="handleRemind(scope.row.id)"
            >提醒续费</el-button
          >
          <el-button size="mini" type="primary" @click="handleInfo(scope.row)">
            学校信息
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="140px">
        <el-form-item label="请上传学校Logo" prop="logo">
          <uploadOne v-model="form.logo" width="80px" height="80px"></uploadOne>
        </el-form-item>
        <el-form-item label="请输入学校名称" prop="name">
          <el-input type="text" v-model="form.name" clearable />
        </el-form-item>
        <el-form-item prop="city_code" label="机构地址:">
          <!-- :rules="[{ required: true, message: '机构地址不能为空' }]" -->
          <el-select
            v-model="form.province_code"
            placeholder="省"
            @change="getReCities(form.province_code)"
            @clear="closeReCities"
            clearable
            style="width: 150px"
          >
            <el-option
              v-for="item in provinces"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>

          <el-select
            v-model="form.city_code"
            class="mg15"
            placeholder="市"
            clearable
            style="width: 150px; margin-left: 10px"
          >
            <el-option
              v-for="item in cities"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系信息" prop="contact_info">
          <el-table size="mini" :data="form.contact_info" border fit>
            <el-table-column label="联系人" align="center" min-width="60">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.contacts" />
              </template>
            </el-table-column>
            <el-table-column label="职务" align="center" min-width="60">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.position" />
              </template>
            </el-table-column>
            <el-table-column label="联系电话" align="center" min-width="60">
              <template slot-scope="scope">
                <el-input
                  onkeyup="this.value=this.value.replace(/\D/g,'')"
                  onafterpaste="this.value=this.value.replace(/\D/g,'')"
                  maxlength="11"
                  size="mini"
                  v-model="scope.row.contact_phone"
                />
              </template>
            </el-table-column>
            <el-table-column
              size="mini"
              label="操作"
              align="center"
              min-width="50"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handelAttrDel(scope.$index)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handelAttrUp(scope.$index)"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handelAttrDown(scope.$index)"
                  >下移</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button class="button-new-tag" size="small" @click="add"
            >+ 添加</el-button
          >
        </el-form-item>
        <el-form-item label="账号" prop="account">
          <el-input type="text" v-model="form.account" clearable />
        </el-form-item>
        <el-form-item label="到期时间" prop="expire_at">
          <el-date-picker
            v-model="form.expire_at"
            type="date"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd"
          >
            <!-- default-time="00:00:00" -->
          </el-date-picker>
          <!-- <el-input type="text" v-model="form.expire_at" clearable /> -->
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">
          确定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="详情信息"
      :visible.sync="dialogInfoVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="140px">
        <el-form-item label="学校Logo:" prop="logo">
          <img src="form.logo" alt="" style="width:80px;height80px" />
        </el-form-item>
        <el-form-item label="学校名称:" prop="name">
          {{ form.name }}
        </el-form-item>
        <el-form-item label="机构地址:" prop="city_code">
          <!-- :rules="[{ required: true, message: '机构地址不能为空' }]" -->
          <el-select
            v-model="form.province_code"
            placeholder="省"
            @change="getReCities(form.province_code)"
            @clear="closeReCities"
            clearable
            style="width: 150px"
            disabled
          >
            <el-option
              v-for="item in provinces"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>

          <el-select
            v-model="form.city_code"
            class="mg15"
            placeholder="市"
            clearable
            style="width: 150px; margin-left: 10px"
            disabled
          >
            <el-option
              v-for="item in cities"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系信息" prop="contact_info">
          <el-table size="mini" :data="form.contact_info" border fit>
            <el-table-column label="联系人" align="center" min-width="60">
              <template slot-scope="scope">
                {{ scope.row.contacts }}
              </template>
            </el-table-column>
            <el-table-column label="职务" align="center" min-width="60">
              <template slot-scope="scope">
                {{ scope.row.position }}
              </template>
            </el-table-column>
            <el-table-column label="联系电话" align="center" min-width="60">
              <template slot-scope="scope">
                {{ scope.row.contact_phone }}
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="账号:" prop="account">
          {{ form.account }}
        </el-form-item>
        <el-form-item label="到期时间:" prop="expire_at">
          <el-date-picker
            v-model="form.expire_at"
            type="date"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd"
            disabled
          >
            <!-- default-time="00:00:00" -->
          </el-date-picker>
          <!-- <el-input type="text" v-model="form.expire_at" clearable /> -->
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogInfoVisible = false">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import UploadOne from "@/components/UploadOne/index.vue";

export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        name: "",
        is_normal: "",
      },
      form: {
        id: "",
        name: "",
        province_code: "",
        city_code: "",
        contact_info: [],
        account: "",
        expire_at: "",
      },
      dialogFormVisible: false,
      dialogInfoVisible: false,
      dialogStatus: "",
      textMap: {
        update: "修改",
        create: "新增",
      },
      rules: {
        logo: [
          { required: true, message: "请上传学校logo", trigger: "change" },
        ],
        name: [
          { required: true, message: "学校名称不能为空", trigger: "change" },
        ],
        account: [
          { required: true, message: "账号不能为空", trigger: "change" },
        ],
        city_code: [
          { required: true, message: "机构地址不能为空", trigger: "change" },
        ],
        contact_info: [
          {
            type: "array",
            required: true,
            message: "联系信息不能为空",
            trigger: "change",
          },
        ],
        expire_at: [
          { required: true, message: "到期时间不能为空", trigger: "change" },
        ],
      },
      btnLoading: false,
      provinces: [],
      cities: [],
    };
  },
  created() {
    this.getList();
    this.getProvince();
  },
  methods: {
    getProvince() {
      return request({
        url: "/api/common/china/provinces",
        method: "get",
      }).then((res) => {
        this.provinces = res.data;
      });
    },
    handelAttrDown(index) {
      if (index >= this.form.contact_info.length - 1) {
        return;
      }
      this.form.contact_info.splice(
        index + 1,
        0,
        this.form.contact_info.splice(index, 1)[0]
      );
    },
    handelAttrUp(index) {
      if (index == 0) {
        return;
      }
      this.form.contact_info.splice(
        index - 1,
        0,
        this.form.contact_info.splice(index, 1)[0]
      );
    },
    handelAttrDel(index) {
      this.form.contact_info.splice(index, 1);
    },
    add() {
      this.form.contact_info.push({ contacts: "", contact_phone: "" });
    },
    getReCities(e) {
      request({
        url: "/api/common/china/cities",
        method: "get",
        params: {
          province_code: e,
        },
      }).then((res) => {
        this.cities = res.data;
      });
    },
    closeReCities() {
      this.cities = [];
      this.form.city_code = "";
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/school/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        name: "",
        province_code: "",
        city_code: "",
        contact_info: [
          {
            contacts: "",
            contact_phone: "",
          },
        ],
        account: "",
        expire_at: "",
      };
    },
    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.getReCities(this.form.province_code);
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleInfo(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      // this.dialogStatus = "update";
      this.dialogInfoVisible = true;
      this.getReCities(this.form.province_code);
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // form.contact_info
          for (let index = 0; index < this.form.contact_info.length; index++) {
            const item = this.form.contact_info[index];
            console.log(item);
            if (!item.contacts) {
              this.$message({
                type: "warning",
                message: "联系人不能为空",
              });
              return;
            } else if (!item.contact_phone) {
              this.$message({
                type: "warning",
                message: "联系人电话不能为空",
              });
              return;
            }
          }
          this.btnLoading = true;
          request({
            url: "/api/backend/school/store",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleStatus(val, text) {
      this.$confirm("此操作将" + text + "该院系, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/school/changeNormal",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    initPassword(val, text) {
      this.$confirm("此操作将" + text + "该院系, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/school/initPassword",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    handleRemind(val) {
      this.$confirm("此操作将提醒该学校续费, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/school/reminderRenewal",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
    handleMajor(row) {
      this.$router.push(`/school/majorlist?id=${row.id}`);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>